export const system_function = {
    uuid: '',
    title: '',
    title_fr: '',
    title_en: '',
    title_en_au: '',
    type: '',
    selection_type: ''
};
